export const BILL_PAYMENT_CONSTANTS = {
    TITLE: "Pay Bill",
    DESCRIPTION: "Complete your payment to proceed",
    BUTTON_TEXT: "Pay Now",
    IMAGE_ALT: "Bill Payment",
    ICON_WIDTH: 102,
    ICON_HEIGHT: 102,
};

export const IMAGES = {
    BILL_PAYMENT: "portal/static-assets/icons/digital-menu/payment/icon-bill-payment.png",
};
